export default "__VITE_ASSET__96f3fb40__"